import styledCss from "@styled-system/css"
import * as React from "react"
import styled from "styled-components"
import { variant } from "styled-system"
import { colors, scale } from "../../styles"
import { Icon, IconTypes } from "../Icon"

export type ContactCardVariant = "normal" | "compact"

export interface ContactCardStyledProps {
	variant?: ContactCardVariant
}

export interface ContactCardProps extends ContactCardStyledProps {
	icon?: IconTypes
	iconSize?: number
	children?: React.ReactNode
}

const Aside = styled.div`
	position: relative;
	display: flex;
	justify-content: center;
	background-color: ${colors.blue11};
	min-width: ${scale.px(7)};
`

const Content = styled.div`
	padding: ${scale.px(2.25)} ${scale.px(3)};
`

const ContactCardStyled = styled.div<ContactCardStyledProps>`
	position: relative;
	display: flex;
	width: 100%;
	height: 100%;
	background-color: ${colors.white};
	border: 1px solid ${colors.blue33};
	border-radius: ${scale.px(3)};
	overflow: hidden;

	&:hover {
		border-color: ${colors.hoverBlue};

		svg path {
			fill: ${colors.hoverBlue};
		}
	}

	${variant({
		variants: {
			normal: styledCss({
				svg: {
					position: "absolute",
					right: scale.px(1.25),
				},
			}),
			compact: styledCss({
				height: scale.px(9.75),
				".cc-content": {
					paddingTop: 0,
					paddingBottom: 0,
					display: "flex",
					alignItems: "center",
				},
				svg: {
					position: "absolute",
					top: "50%",
					transform: "translateY(-50%)",
				},
				"> svg": {
					right: scale.px(1.5),
				},
			}),
		},
	})}
`

const ContactCard: React.FC<ContactCardProps> = ({
	children,
	icon,
	iconSize,
	...rest
}) => {
	return (
		<ContactCardStyled {...rest}>
			{icon && (
				<Aside>
					<Icon
						icon={icon}
						size={iconSize ?? 4}
						mt={rest.variant === "normal" ? 1.5 : 0}
					/>
				</Aside>
			)}
			<Content className="cc-content">{children}</Content>
			<Icon
				icon="arrow-right"
				size={3}
				mt={rest.variant === "normal" ? 2 : 0}
			/>
		</ContactCardStyled>
	)
}

ContactCard.defaultProps = {
	variant: "normal",
}

export { ContactCard }
